import { all } from 'redux-saga/effects';

//public
import AuthSaga from './auth/saga';
import DashboardSaga from './dashboard/saga';
import LayoutSaga from './layout/saga';
import SubscriptionsSaga from './subscriptions/saga';
import InvoicesSaga from './invoices/saga';
import UserSaga from './users/saga';
import AffiliateSaga from './affiliates/saga';
import CommissionSaga from './commissions/saga';
import DiscountCodesSaga from './discountCodes/saga';

export default function* rootSaga() {
  yield all([
    AuthSaga(),
    LayoutSaga(),
    DashboardSaga(),
    SubscriptionsSaga(),
    InvoicesSaga(),
    UserSaga(),
    AffiliateSaga(),
    CommissionSaga(),
    DiscountCodesSaga(),
  ]);
}
